import SignageStudioLogo from "@components/shared/SignageStudioLogo";
import Link from "next/link";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedin,
} from "react-icons/fa";

function Footer() {
  return (
    <div className="flex w-full flex-col items-center gap-7 bg-footerBackground px-16 py-10">
      <div className="w-48">
        <a href="https://signagestudio.io">
          <SignageStudioLogo />
        </a>
      </div>
      <div className="flex w-full flex-col items-center justify-between gap-7 text-white lg:flex-row">
        <div className="flex-1">
          <CopyrightSection />
        </div>
        <QuickLinksSection />

        <div className="flex flex-1 justify-end">
          {/* <SocialIconsSection /> */}
        </div>
      </div>
    </div>
  );
}

function CopyrightSection() {
  const year = new Date().getFullYear();
  return (
    <div className="text-sm">{`Copyright © ${year} Signage Studio.`}</div>
  );
}

function QuickLinksSection() {
  return (
    <div className="flex gap-4 text-sm">
      <Link href="https://signagestudio.io/features" target={"_blank"}>
        Features
      </Link>
      <Link href="https://signagestudio.io/pricing">Pricing</Link>
      <Link href="https://signagestudio.io/privacy">Privacy Policy</Link>
      <Link href="https://signagestudio.io/terms">Terms of Service</Link>
    </div>
  );
}

function SocialIconsSection() {
  return (
    <div className="flex gap-3">
      <Link href="/about">
        <FaFacebookF />
      </Link>
      <Link href="/about">
        <FaInstagram />
      </Link>
      <Link href="/terms">
        <FaTwitter />
      </Link>
      <Link href="/privacy">
        <FaLinkedin />
      </Link>
    </div>
  );
}

export default Footer;
